export enum ChannelType {
    DIGITAL_CONTACT = 1,
    DIGITAL_MOTOR = 2,

    ANALOG_420MA_PT = 21,
    ANALOG_420MA_AI = 22,
    ANALOG_1_5_V = 23,
    ANALOG_PT100_3WIRE = 24,
    ANALOG_PT100_2WIRE = 25,
    ANALOG_TEMP_K = 26,

    EXH_GAS_DEV = 31,
    EXH_GAS_MEAN = 32,

    FLOW_TOTAL = 41,
    FLOW_DAY = 42,

    RUNNING_TOTAL = 51,
    RUNNING_DAY = 52,

    BLANK = 100
}

export const ChannelTypeStrings = {};
ChannelTypeStrings[ChannelType.DIGITAL_CONTACT] = 'Digital (contact)';
ChannelTypeStrings[ChannelType.DIGITAL_MOTOR] = 'Digital (Motor)';

ChannelTypeStrings[ChannelType.ANALOG_420MA_AI] = 'Analog (4-20mA AI)';
ChannelTypeStrings[ChannelType.ANALOG_420MA_PT] = 'Analog (4-20mA PT)';
ChannelTypeStrings[ChannelType.ANALOG_1_5_V] = 'Analog (1-5V)';
ChannelTypeStrings[ChannelType.ANALOG_PT100_3WIRE] = 'Analog (Temp Pt100 3-wire)';
ChannelTypeStrings[ChannelType.ANALOG_PT100_2WIRE] = 'Analog (Temp Pt100 2-wire)';
ChannelTypeStrings[ChannelType.ANALOG_TEMP_K] = 'Analog (Temp K)';

ChannelTypeStrings[ChannelType.EXH_GAS_DEV] = 'Exhaust gas dev';
ChannelTypeStrings[ChannelType.EXH_GAS_MEAN] = 'Exhaust gas mean';

ChannelTypeStrings[ChannelType.FLOW_TOTAL] = 'Flow counter (total)';
ChannelTypeStrings[ChannelType.FLOW_DAY] = 'Flow counter (day)';

ChannelTypeStrings[ChannelType.RUNNING_TOTAL] = 'Running hour (total)';
ChannelTypeStrings[ChannelType.RUNNING_DAY] = 'Running hour (day)';

export const ChannelTypeStringLookup = {};
for (let type in ChannelTypeStrings) {
    ChannelTypeStringLookup[ChannelTypeStrings[type]] = Number(type);
}

export function getDigitalTypesSet() {
    return new Set([ChannelType.DIGITAL_CONTACT, ChannelType.DIGITAL_MOTOR]);
}

export function getAnalogTypesSet() {
    return new Set([
        ChannelType.ANALOG_420MA_AI,
        ChannelType.ANALOG_420MA_PT,
        ChannelType.ANALOG_1_5_V,
        ChannelType.ANALOG_PT100_3WIRE,
        ChannelType.ANALOG_PT100_2WIRE,
        ChannelType.ANALOG_TEMP_K,
        ChannelType.EXH_GAS_DEV,
        ChannelType.EXH_GAS_MEAN
    ]);
}

const digitalTypes = new Set([ChannelType.DIGITAL_CONTACT, ChannelType.DIGITAL_MOTOR]);
const runningHourTypes = new Set([ChannelType.FLOW_TOTAL, ChannelType.FLOW_DAY, ChannelType.RUNNING_TOTAL, ChannelType.RUNNING_DAY]);

export function isBlank(type: ChannelType) {
    return ChannelType.BLANK == type;
}

export function isDigital(type: ChannelType) {
    return digitalTypes.has(type);
}

export function isAnalog(type: ChannelType) {
    return getAnalogTypesSet().has(type);
}

export function isRunningHour(type: ChannelType) {
    return runningHourTypes.has(type);
}